import { b as ariaAttributeName, c as ariaMixinProperties, A as AttachedBehaviorHTMLDirective } from './vivid-element.js';
import { A as AttributeBindingBehavior } from './attribute-binding-behaviour.js';

class HostSemanticsBehavior {
  constructor(target, params) {
    this.target = target;
    this.bindingBehaviours = [];
    this.boundProperties = params.boundProperties;
  }
  bind(source) {
    if (this.target !== source) {
      throw new Error("Target element must be the same as the source element");
    }
    this.bindPropertiesToTarget(source, this.boundProperties, this.target);
  }
  unbind(source) {
    this.releasePropertyBindings(source);
  }
  bindPropertiesToTarget(source, boundProperties, target) {
    for (const [property, binding] of Object.entries(boundProperties)) {
      const bindingFn = binding instanceof Function ? binding : (x) => x[property] ?? binding;
      this.bindingBehaviours.push(
        new AttributeBindingBehavior(
          target,
          bindingFn,
          true,
          ariaAttributeName(property)
        )
      );
    }
    source.$fastController.addBehaviors(this.bindingBehaviours);
  }
  releasePropertyBindings(source) {
    source.$fastController.removeBehaviors(this.bindingBehaviours);
    this.bindingBehaviours = [];
  }
}

function applyHostSemantics(boundProperties = {}) {
  const forwardedProperties = new Set(
    ariaMixinProperties.filter((p) => !(p in boundProperties))
  );
  return new AttachedBehaviorHTMLDirective(
    "vvd-host-semantics",
    HostSemanticsBehavior,
    {
      boundProperties,
      forwardedProperties
    }
  );
}
const HostSemantics = (Base) => {
  class HostSemanticsElement extends Base {
    constructor() {
      super(...arguments);
      this._vividAriaBehaviour = "host";
    }
  }
  return HostSemanticsElement;
};

export { HostSemantics as H, applyHostSemantics as a };
